module.exports = __webpack_public_path__ + "static/media/YF01_7.2e742ff1.jpg";